<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="row">

            <div class="col-md-12 rolelist">
                <div class="addrole">
                    <router-link to="/admin/dashboard/addproduct"><a class="">Add Product</a></router-link>
                </div>
            </div>
            <div class="col-md-12 rolelistupper">
                <div class="card">
                    <h5 class="card-title">Product List</h5>

                    <FlashMessage :position="'right top'"></FlashMessage>
                    <div class="card-body table-responsive table-full-width">
                        <table class="table table-borderd mt-5" id="myTable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Category</th>
                                    <th>Subcategory</th>
                                    <th>Product</th>
                                    <th>SKU</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>image</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in tableData" v-bind:key="data.productid">
                                    <td>{{data.productid}}</td>
                                    <td>{{data.categoryname}}</td>
                                    <td>{{data.subcategoryname}}</td>
                                    <td>{{data.productname}}</td>
                                    <td>{{data.sku}}</td>
                                    <td>₹{{data.price}}</td>
                                    <td>{{data.quantity}}</td>
                                    <td><img :src="api+'/storage/image/'+image[index]" height="50px" width="50px"></td>
                                    <td>{{data.status}}</td>
                                    <td><button @click.prevent="deleteData(data.productid)" class="btnborderremove">
                                            <a><b-icon-trash></b-icon-trash></a>
                                        </button>&nbsp; &nbsp; <router-link :to="'/admin/dashboard/editproduct/' + data.productid"><button class="btnborderremove">
                                                <a><b-icon-pencil-square></b-icon-pencil-square></a>
                                            </button></router-link>
                                    </td>

                                </tr>
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import datatable from "datatables.net-bs4"
import Vue from 'vue'
import $ from "jquery"
import {
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
    name: 'listProduct',

    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            api: process.env.VUE_APP_API_BASE_URL,
            tableData: [],
            image: [],
        }
    },

    methods: {

        table() {
            this.$nextTick(() => {
                $('#myTable').DataTable();
            });
        },

        getData() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/product`).then((res) => {
                this.tableData = res.data;
                let i = 0;
                let a = [];
                var all = new Array();
                for (i = 0; i < res.data.length; i++) {
                    a = res.data[i].productimage.toString().split('|');
                    all[i] = a[0];
                }
                this.image = all;
                this.table();
            });
        },

        deleteData(productid) {
            this.axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/product/delete/` + productid).then((res) => {
                this.list = res;
                this.getData();
                this.flashMessage.success({
                    message: 'Product Deleted Successfully',
                });
            });
        },

    },

    mounted() {
        this.getData();
    },

};
</script>

<style lang="scss">
</style>
